export const FooterData = [
  {
    titleHeader: "Company",
    title: [
      {
        Name: "About Us",
        href: "about-us",
      },
      {
        Name: "Contact Us",
        href: "contact-us",
      },
      {
        Name: "Careers",
        href: "#",
      },
      {
        Name: "Latest news",
        href: "#",
      },
    ],
  },
  {
    titleHeader: "Top Category",
    title: [
      {
        Name: "Fish & Meat",
        href: "fish--meat",
      },
      {
        Name: "Soft Drinks",
        href: "drinks",
      },
      {
        Name: "Baby Care",
        href: "baby-care",
      },
      {
        Name: "Beauty & Health",
        href: "beauty--health",
      },
    ],
  },
  {
    titleHeader: "My Account",
    title: [
      {
        Name: "Dashboard",
        href: "dashboard",
      },
      {
        Name: "My Orders",
        href: "my-orders",
      },
      {
        Name: "Recent Orders",
        href: "dashboard",
      },
      {
        Name: "Updated Profile",
        href: "updated-profile",
      },
    ],
  },

];
